module.exports = __webpack_public_path__ + "img/hero@2x.19dbbacd.webp";